<div id="boton-home-{{infoLineaActiva.ref}}-mb" class="container px-0">
 <div class="row">
  <div class="col-12 d-block d-lg-none">
    <div class="dropdown">
      <button class="btn custom-btn bg-primary-50 shadow-8 w-100 text-start px-3 py-2" type="button"
        id="dropdownLineaInversion" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="row">
          <div class="col d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div
                class="me-2 circle-container-36 d-flex justify-content-center align-items-center bg-{{infoLineaActiva.lineaColorActive}}">
                <span class="material-symbols-outlined primary-50">{{infoLineaActiva.segoMatIconName}}</span>
              </div>
              <div class="ms-1">
                <p class="primary-900 tabs" [innerHtml]="infoLineaActiva.pretitulo"></p>
                <p class="neutral-900 p3-regular" [innerHtml]="infoLineaActiva.segoInvertir">
                </p>
              </div>
            </div>
            <div class="d-flex">
              <span class="material-symbols-outlined dropdown-icon primary-800 mt-1">keyboard_arrow_down</span>
            </div>
          </div>
        </div>
      </button>
    
      <ul class="dropdown-menu filtro mt-1 shadow-8 w-100" aria-labelledby="dropdownLineaInversion">
        @if (!isRouteCnmv) {
        <li class="primary-900 p1-semibold px-3 py-2">Financiación Participativa</li>
        }
        @for (info of infoLineasParticipativas; track info.ref) {
        <li>
          <a class="bg-selected-item dropdown-item px-3 py-2" href="javascript:void(0)"
             (click)="setLineaActiva(info.ref)">
            <div class="row d-flex align-items-center">
              <div class="col-12 d-flex align-items-center">
                <div
                  class="me-2 circle-container-36 d-flex justify-content-center align-items-center bg-{{info.lineaColorActive}}">
                  <span class="material-symbols-outlined primary-50">{{info.segoMatIconName}}</span>
                </div>
                <div class="ms-1">
                  <p class="primary-900 tabs" [innerHtml]="info.pretitulo"></p>
                  <p class="neutral-900 p3-regular" [innerHtml]="info.segoInvertir"></p>
                </div>
              </div>
            </div>
          </a>
        </li>
        }
        @if (!isRouteCnmv) {
        <li class="primary-900 p1-semibold px-3 py-2">Otros Productos</li>
        }
        @for (info of infoLineasNoParticipativas; track info) {
        <li class="py-1">
          <a class="bg-selected-item dropdown-item px-3 py-2" href="javascript:void(0)"
            (click)="setLineaActiva(info.ref)">
            <div class="row d-flex align-items-center">
              <div class="col-12 d-flex align-items-center">
                <div
                  class="me-2 circle-container-36 d-flex justify-content-center align-items-center bg-{{info.lineaColorActive}}">
                  <span class="material-symbols-outlined primary-50">{{info.segoMatIconName}}</span>
                </div>
                <div class="ms-1">
                  <p class="primary-900 tabs" [innerHtml]="info.pretitulo"></p>
                  <p class="neutral-900 p3-regular" [innerHtml]="info.segoInvertir"></p>
                </div>
              </div>
            </div>
          </a>
        </li>
        }
      </ul>
    </div>
  </div>
 </div>
</div>